// extracted by mini-css-extract-plugin
export default {"container":"style_container__-bZWv","canvas":"style_canvas__nZ+AZ"};